var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("BlBackdrop", { attrs: { footer: false } }, [
    _c(
      "div",
      { staticClass: "flex flex-col gap-2 px-8 pt-8 pb-4" },
      [
        _vm.destinationStage.is_admitted
          ? _c("BlTextTitle4", { attrs: { text: "Confirm client admission" } })
          : _vm._e(),
        _vm._v(" "),
        _vm.destinationStage.is_discontinued
          ? _c("BlTextTitle4", {
              attrs: { text: "Reason for discontinuation" }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "flex" }, [
          _c(
            "div",
            {
              staticClass:
                "flex items-center gap-1 px-1 rounded h-7 bg-tulip-100"
            },
            [
              _c("BlIcon", {
                staticClass: "w-6 h-6",
                attrs: { icon: "user-square", color: "tulip-7" }
              }),
              _vm._v(" "),
              _c("BlTextSubtitle3", {
                staticClass: "text-tulip-700",
                attrs: { text: _vm.prospectStage.prospect.name }
              })
            ],
            1
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _vm.celebrationPopup
      ? _c(
          "div",
          {
            staticClass:
              "flex flex-col items-center justify-center w-full h-full px-8 pb-8"
          },
          [
            _c("BlGif", {
              staticClass: "rounded-full h-72 w-72",
              attrs: { gif: "celebration" }
            }),
            _vm._v(" "),
            _c("BlTextTitle4", {
              staticClass: "text-light-purple",
              attrs: { text: "Congratulations! You've just converted a" }
            }),
            _vm._v(" "),
            _c("BlTextTitle4", {
              staticClass: "text-light-purple",
              attrs: { text: "prospect into a client! " }
            })
          ],
          1
        )
      : _vm.modalLoading
      ? _c(
          "div",
          {
            staticClass:
              "flex flex-col items-center justify-center gap-4 px-8 overflow-y-auto h-128",
            style: { width: "40rem" }
          },
          [_c("div", { staticClass: "blum-loader" })]
        )
      : _c("div", { style: { width: "40rem" } }, [
          _vm.destinationStage.is_discontinued
            ? _c(
                "div",
                { staticClass: "flex flex-col gap-4 px-8" },
                [
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        "Please provide the reason for the prospect's decision to discontinue during the client acquisition process. If the prospect returns, their profile can be reopened at any time."
                    }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "flex flex-col gap-1" },
                    [
                      _c("BlSelectBox", {
                        attrs: {
                          placeholder: "Select reason",
                          options: _vm.reasonOptions
                        },
                        on: {
                          change: function($event) {
                            _vm.reasonInput = $event
                          }
                        },
                        model: {
                          value: _vm.reasonInput,
                          callback: function($$v) {
                            _vm.reasonInput = $$v
                          },
                          expression: "reasonInput"
                        }
                      }),
                      _vm._v(" "),
                      _vm.reasonInput === "other"
                        ? _c("BlInputText", {
                            attrs: { input: _vm.otherReasonInput },
                            on: { changed: _vm.inputHandler }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.destinationStage.is_admitted
            ? _c(
                "div",
                {
                  staticClass: "flex flex-col gap-4 px-8 overflow-y-auto",
                  style: { maxHeight: "calc(100vh - 8rem)" }
                },
                [
                  _c(
                    "div",
                    [
                      _c("BlTextBody2", {
                        attrs: { text: "By moving this prospect to " }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        staticClass: "font-bold",
                        attrs: { text: "''Admitted'' " }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: {
                          text:
                            ", you'll create a client profile using their acquisition information. Before finalizing, you can select the necessary files/ documents to include in the client profile. These documents will be accessible to everyone in the center."
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.prospectInformation
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "flex flex-col gap-2 p-2 rounded bg-slate-200"
                        },
                        [
                          !_vm.prospectInformation.documents.length
                            ? _c("BlTextBody2", {
                                staticClass: "text-center",
                                attrs: {
                                  text:
                                    "No documents available to include in the client profile."
                                }
                              })
                            : _vm._l(
                                _vm.prospectInformation.documents,
                                function(doc) {
                                  return _c("BlFileHolder", {
                                    key: doc.id,
                                    attrs: {
                                      name: doc.blob.filename,
                                      size: doc.blob.byte_size,
                                      checkable: "",
                                      checked: _vm.documentsInput.includes(
                                        doc.id
                                      )
                                    },
                                    on: {
                                      "check-handler": function($event) {
                                        return _vm.onCheckDoc(doc.id)
                                      }
                                    }
                                  })
                                }
                              )
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.enableBranch
                    ? _c(
                        "div",
                        { staticClass: "flex flex-col gap-2" },
                        [
                          _c("BlTextBody2", {
                            attrs: {
                              text:
                                "Select branch tag for this prospect. The tag will be visible in their profile. (Optional)"
                            }
                          }),
                          _vm._v(" "),
                          _c("BlSearchBox", {
                            attrs: {
                              type: "branch",
                              drop: "up",
                              placeholder: "Type tag",
                              options: _vm.branchOptions
                            },
                            on: {
                              change: function($event) {
                                _vm.branchesInput = $event
                              }
                            },
                            model: {
                              value: _vm.branchesInput,
                              callback: function($$v) {
                                _vm.branchesInput = $$v
                              },
                              expression: "branchesInput"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c("BlTextBody2", {
                        attrs: {
                          text:
                            "You can always edit the information in the client profile later if needed."
                        }
                      })
                    ],
                    1
                  )
                ]
              )
            : _vm._e()
        ]),
    _vm._v(" "),
    !_vm.celebrationPopup
      ? _c(
          "div",
          { staticClass: "flex items-center justify-end gap-4 px-8 pt-4 pb-8" },
          [
            _c("BlInputButton", {
              attrs: { type: "plain", label: "Cancel" },
              on: {
                clicked: function($event) {
                  return _vm.$emit("close-modal")
                }
              }
            }),
            _vm._v(" "),
            _c("BlInputButton", {
              attrs: {
                label: _vm.destinationStage.is_admitted
                  ? "Confirm admission"
                  : "Submit",
                disabled: _vm.isDisabledSubmit,
                loading: _vm.submitLoading
              },
              on: { clicked: _vm.onSubmit }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1c3d978d", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1c3d978d","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/modal/MoveProspectModal.vue
// module id = null
// module chunks = 